<template>
    <scroll-item
        :id="id"
    >
        <div
            :id="id"
            class="report-section"
        >
            <div
                v-if="title"
                class="title header"
            >
                <slot name="header-image" />
                <div class="header-text">
                    <h2
                        class="title section-title is-2"
                    >
                        <a
                            :href="'#' + id"
                            class="section-link"
                            @click="setHash($event, id)"
                            v-text="title"
                        />
                    </h2>
                    <h3
                        v-if="subtitle"
                        class="subtitle section-subtitle is-3"
                        v-text="subtitle"
                    />
                </div>
            </div>
            <div class="section-content">
                <slot />
            </div>
        </div>
    </scroll-item>
</template>

<script>
export default {
    name: 'ReportSection',

    props: {
        id: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        subtitle: {
            type: String,
            required: false,
            default: '',
        },
    },

    methods: {
        setHash(e, sectionId) {
            // update url hash
            window.history.replaceState({}, '', `#${sectionId}`);

            // scroll element into view, if it exists
            const el = document.getElementById(sectionId);
            if (el) {
                el.scrollIntoView(true);
            }

            e.preventDefault();
            e.stopPropagation();
        },
    },

};
</script>

<style lang="scss">
$section-margin-bottom: 2.5rem !default;
$table-borders: #695d46 !default;
$section-divider-color: #e6e6e6 !default;

.report-section {
    padding: 0 0 3rem 0;
    border-bottom: 1px solid $section-divider-color;
    margin-bottom: $section-margin-bottom;

    .header {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 1.5rem;

        .header-text {
            flex: 1;

            .title {
                margin-bottom: 0;
            }
            .subtitle {
                margin-top: 0;
            }
        }
    }

    .table,
    .table th {
        color: $table-borders;
    }
}
</style>
